import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAcademy } from '@/hooks/useAcademy';
import CursoCard from '@/components/CursoCard';
import { Loader2, Search } from 'lucide-react';
import { useToast } from '@/components/ui/use-toast';
import { MODULES } from '@/constants/branding';
import { Helmet } from 'react-helmet';
import GlobalNavbar from '@/components/GlobalNavbar';
import Footer from '@/components/Footer';
import '@/styles/provatio-unified-design.css';

export default function AcademyPage() {
  const { cursos, matriculas, loading, error, matricular } = useAcademy();
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleMatricular = async (cursoId) => {
    try {
      await matricular(cursoId);
      toast({ title: "Sucesso", description: "Matrícula realizada com sucesso!" });
      navigate(`/academy/curso/${cursoId}`);
    } catch (error) {
      toast({ variant: "destructive", title: "Erro", description: error.message || "Não foi possível realizar a matrícula." });
    }
  };

  const filteredCursos = cursos.filter(c => c.titulo?.toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div className="min-h-screen flex flex-col provatio-unified bg-[#F8FAFB]">
      <GlobalNavbar />
      <Helmet>
         <title>{MODULES.ACADEMY}</title>
      </Helmet>
      
      <main className="flex-1 py-12 px-6">
        <div className="container mx-auto max-w-7xl space-y-8">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 border-b border-[#E5E7EB] pb-6">
            <div>
              <h1 className="text-3xl font-bold text-[#193D6D]">{MODULES.ACADEMY}</h1>
              <p className="text-[#6B7280] mt-2">Aprimore seus conhecimentos com nossos cursos especializados.</p>
            </div>
            <div className="relative w-full md:w-96">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input 
                className="w-full border rounded-md py-2 pl-10 pr-4 focus:outline-none focus:ring-2 focus:ring-[#193D6D]" 
                placeholder="Buscar cursos..." 
                value={searchTerm} 
                onChange={e => setSearchTerm(e.target.value)} 
              />
            </div>
          </div>
          
          {error && (
            <div className="bg-red-50 text-red-600 p-4 rounded-md border border-red-200">
              {error}
            </div>
          )}

          {loading ? (
            <div className="flex justify-center p-20"><Loader2 className="animate-spin h-8 w-8 text-[#193D6D]" /></div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredCursos.length > 0 ? filteredCursos.map(curso => {
                const isMatriculado = matriculas.some(m => m.curso_id === curso.id);
                return (
                  <div key={curso.id} className="pv-card h-full flex flex-col bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                     <CursoCard 
                        curso={curso} 
                        isMatriculado={isMatriculado}
                        onAcessar={() => navigate(`/academy/curso/${curso.id}`)}
                        onComprar={() => handleMatricular(curso.id)}
                      />
                  </div>
                );
              }) : (
                <div className="col-span-full text-center py-12 text-gray-500">
                  Nenhum curso encontrado.
                </div>
              )}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}